import { render, staticRenderFns } from "./DocumentsLibrary.vue?vue&type=template&id=539bda9d&scoped=true&"
import script from "./DocumentsLibrary.vue?vue&type=script&lang=js&"
export * from "./DocumentsLibrary.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsLibrary.vue?vue&type=style&index=0&id=539bda9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539bda9d",
  null
  
)

export default component.exports